/* eslint-disable react/jsx-props-no-spreading */
import { GridCellProps } from '@progress/kendo-react-grid';
import * as React from 'react';
import { DropDownListOption } from '../../models/DropDownListOption';
import useClientContextStore from '../../zustandStore/clientContextStore';

const FamilyMemberCell = (cellProps: GridCellProps) => {
	const clientWithOwnerDetails = useClientContextStore((state) => state.clientWithOwnerDetails);

	return (
		<td>
			<div>{getFamilyMemberName(cellProps.dataItem.clientId, clientWithOwnerDetails)}</div>
		</td>
	);
};

export default FamilyMemberCell;

export const getFamilyMemberName = (
	familyMemberClientId: number,
	clientWithOwnerDetails: DropDownListOption<number>[]
) => clientWithOwnerDetails.find((x) => x.value === familyMemberClientId)?.text ?? '';
